module.exports = __webpack_public_path__ + "static/media/parentportal2.b36543d0.svg";